import React, { Component } from 'react';
import './Menu.css';


class Menu extends Component {
  /*constructor (props) {
    super(props);
  }*/

  gotoApp(id) {
    window.location.href = "#app" + id;
    this.props.onClick();
  }

  render() {
    return (
      <ul className={this.props.showMenu?"app_menu app_menu_show":"app_menu app_menu_hide"}>
        {this.props.apps.map(
          (app, i) => {
            return (
                <li key={i} onClick={() => this.gotoApp(i)}>
                <img src={app.appIcon} alt={app.appName} />
                <span>{app.appName}</span>
                <div className="app_menu_right">
                {app.appLinkA
                ?<a href={app.appLinkA} target="_blank" rel="noopener noreferrer">iOS</a>
                :null}
                {app.appLinkG
                ?<a href={app.appLinkG} target="_blank" rel="noopener noreferrer">Android</a>
                :null}
                {app.appLinkR
                ?<a href={app.appLinkR} target="_blank" rel="noopener noreferrer">Roblox</a>
                :null}
                </div>
                </li>
            );
          }
        )}
      </ul>
    );
  }
}

export default Menu;
